module.exports = __webpack_public_path__ + "fd95f8702397c8524134fa10bc0c19b8.svg";